var jQuery = require('jquery');
var config = require("config");
var angular = require("angular");

// Define a new module for our app. The array holds the names of dependencies if any.
var app = angular.module("filterOffice", []);

// Create the instant search filter



app.filter('searchFor', function(){

    // All filters must return a function. The first parameter
    // is the data that is to be filtered, and the second is an
    // argument that may be passed with a colon (searchFor:searchString)

    return function(arr, searchString){

        if(!searchString){
            return [];
        }

        var result = [];
        var isInPlaces = false;

        searchString = searchString.toLowerCase();

        // Using the forEach helper method to loop through the array
        angular.forEach(arr, function(item){

            isInPlaces = false;


            if (item.Name.toLowerCase().indexOf(searchString) !== -1) {
              isInPlaces = true;
            }
            else {
                for (var i = 0; i < item.Cities.length; i++) {

                    if(item.Cities[i].toLowerCase().indexOf(searchString) !== -1){
                        isInPlaces = true;
                        break;
                    }
                }
            }

            if (item.Sdr === 0){
                isInPlaces = false;
            }


           if(isInPlaces){
                result.push(item);
            }

        });

        return result;
    };

});



// The controller

function InstantFilterController($scope, $http) {
    var lang = "sv";
    $scope.areasupdate = function () {
        window.location.href = $scope.office.Url;
    };
    $scope.office = undefined;
    $scope.offices = [];
    $scope.items = [];
    $scope.state = "waiting";

    $http.get("/umbraco/SDRActions/LocalOfficesApi/GetOffices")
    	.then(function (r) {
    	    if (r.status === 200) {
    	        $scope.items = r.data;
    	        angular.forEach($scope.items, function (it) {
                    it.Url = "/" + lang + "/find-office/" + it.Sdr + it.Url;
    	        });
    	        $scope.offices = $scope.items;

                $scope.office = {
                    Cities: [],
                    Sdr: 0,
                    Url: ""
                };
    	        $scope.state = "loaded";
    	    }
    	});
}

function currentLanguage() {
    var lang;
    var urlSegs = window.location.pathname.split("/");
    if (urlSegs.length > 1) {
        lang = urlSegs[1];
    }
    return lang || "sv";
}

app.controller("InstantFilterController", InstantFilterController);

app.directive("filterSelectric", [
    function() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs) {
                scope.$watch(attrs.ngModel, function(newVal, oldVal) {
                    // console.log(jQuery("option", element).length);
                    jQuery(element).selectric({
                        maxHeight: 200,
                        responsive: true,
                        disableOnMobile: false
                    });
                })

            }
        }
    }
]);
























/*****************
 ** WEBPACK FOOTER
 ** ./assets_src/js/angular.filteroffice.js
 ** module id = 1
 ** module chunks = 0
 **/